module.exports = __webpack_public_path__ + "static/banner-1dcea4452dc80be37f716279b2308498.jpg";